<div class="wiz">
  <!-- ── Banner + stepper ─────────────────────────────────────────────────── -->
  <div class="wiz__banner" *ngIf="!submitted">
    <div class="wiz__banner-inner">
      <a routerLink="/portal" class="wiz__back"><i class="bi bi-arrow-left portal-arrow"></i> {{ "joinTenant.BackToHome" | translate }}</a>
      <span class="wiz__pill"><i class="bi bi-stars"></i> {{ "joinTenant.TrialPill" | translate }}</span>
      <h1 class="wiz__title">{{ "joinTenant.Title" | translate }}</h1>
      <p class="wiz__lead">{{ "joinTenant.Lead" | translate }}</p>
    </div>

    <div class="wiz__steps">
      <div class="wiz__steps-track">
        <span class="wiz__steps-fill" [style.width]="step === 1 ? '0%' : step === 2 ? '50%' : '100%'"></span>
      </div>
      <div class="wiz__step-dot" *ngFor="let s of [{n:1,l:'Organization'},{n:2,l:'Choose plan'},{n:3,l:'Contact'}]">
        <span class="wiz__step-bullet" [class.is-done]="s.n < step" [class.is-active]="s.n === step">
          <i class="bi bi-check-lg" *ngIf="s.n < step"></i>
          <ng-container *ngIf="s.n >= step">{{ s.n }}</ng-container>
        </span>
        <span class="wiz__step-label" [class.is-active]="s.n <= step">{{ s.l }}</span>
      </div>
    </div>

    <svg class="wiz__wave" viewBox="0 0 1440 40" preserveAspectRatio="none" fill="none">
      <path d="M0,20 C360,40 1080,0 1440,20 L1440,40 L0,40 Z" fill="#f0f4ff" />
    </svg>
  </div>

  <!-- ── Form card ────────────────────────────────────────────────────────── -->
  <div class="wiz__body" *ngIf="!submitted; else done">
    <form class="wiz__card" [formGroup]="form" (ngSubmit)="submit()" novalidate>

      <!-- Step 1: Organization -->
      <div *ngIf="step === 1">
        <h2 class="wiz__card-title">{{ "joinTenant.OrgCardTitle" | translate }}</h2>
        <p class="wiz__card-sub">{{ "joinTenant.OrgCardSub" | translate }}</p>

        <div class="field">
          <label class="field__label" for="organizationName">{{ "joinTenant.OrgNameLabel" | translate }}</label>
          <input id="organizationName" type="text" class="field__input"
            formControlName="organizationName" [placeholder]="'joinTenant.OrgNamePlaceholder' | translate" />
          <small class="field__error" *ngIf="f['organizationName'].touched && f['organizationName'].invalid">
            {{ "joinTenant.OrgNameRequired" | translate }}
          </small>
        </div>

        <div class="field">
          <label class="field__label">{{ "joinTenant.OrgTypeLabel" | translate }}</label>
          <div class="chips">
            <button type="button" class="chip" *ngFor="let t of orgTypes"
              [class.is-selected]="orgType === t.value" (click)="selectOrgType(t.value)">{{ t.key | translate }}</button>
          </div>
        </div>

        <div class="field">
          <label class="field__label" for="preferredSubdomain">{{ "joinTenant.SubdomainLabel" | translate }}</label>
          <div class="field__group">
            <input id="preferredSubdomain" type="text" class="field__input"
              formControlName="preferredSubdomain" [placeholder]="'joinTenant.SubdomainPlaceholder' | translate"
              (input)="normalizeSubdomain()" />
            <span class="field__suffix">{{ domainSuffix }}</span>
          </div>
          <small class="field__error" *ngIf="f['preferredSubdomain'].touched && f['preferredSubdomain'].invalid">
            <ng-container *ngIf="f['preferredSubdomain'].errors?.['subdomainTooShort']">{{ "joinTenant.SubdomainTooShort" | translate }}</ng-container>
            <ng-container *ngIf="f['preferredSubdomain'].errors?.['subdomainReserved']">{{ "joinTenant.SubdomainReserved" | translate }}</ng-container>
            <ng-container *ngIf="!f['preferredSubdomain'].errors?.['subdomainTooShort'] && !f['preferredSubdomain'].errors?.['subdomainReserved']">{{ "joinTenant.SubdomainFormat" | translate }}</ng-container>
          </small>
          <p class="field__hint"><i class="bi bi-globe2"></i> {{ "joinTenant.Preview" | translate }} <strong dir="ltr">{{ subdomainPreview }}</strong></p>
        </div>
      </div>

      <!-- Step 2: Plan -->
      <div *ngIf="step === 2">
        <h2 class="wiz__card-title">{{ "joinTenant.PlanCardTitle" | translate }}</h2>
        <p class="wiz__card-sub">{{ "joinTenant.PlanCardSub" | translate }}</p>

        <div class="wiz__plan-controls" *ngIf="plans.length">
          <div class="seg">
            <button type="button" [class.is-active]="interval === 1" (click)="setInterval(1)">{{ "portal.Monthly" | translate }}</button>
            <button type="button" [class.is-active]="interval === 2" (click)="setInterval(2)">{{ "portal.Annual" | translate }}</button>
          </div>
          <div class="seg">
            <button type="button" *ngFor="let cur of currencies"
              [class.is-active]="selectedCurrency === cur" (click)="setCurrency(cur)">{{ cur }}</button>
          </div>
        </div>

        <div class="wiz__plans" *ngIf="plans.length; else noPlans">
          <button type="button" class="wiz__plan" *ngFor="let p of plans; let i = index"
            [class.is-selected]="selectedPlanCode === p.code" (click)="selectPlan(p.code)">
            <span class="wiz__plan-check"><i class="bi bi-check-lg"></i></span>
            <div class="wiz__plan-main">
              <div class="wiz__plan-name">
                {{ planName(p) }}
                <span class="wiz__plan-pop" *ngIf="isPopular(i)">{{ "joinTenant.Popular" | translate }}</span>
              </div>
              <div class="wiz__plan-students">{{ planStudents(p) || planDescription(p) }}</div>
            </div>
            <div class="wiz__plan-price">
              <ng-container *ngIf="priceFor(p) != null; else contact">
                <span class="wiz__plan-amount">{{ priceFor(p) | number:'1.0-0' }}</span>
                <span class="wiz__plan-cur">{{ selectedCurrency }}</span>
                <span class="wiz__plan-per">/{{ interval === 2 ? 'yr' : 'mo' }}</span>
              </ng-container>
              <ng-template #contact><span class="wiz__plan-amount wiz__plan-amount--sm">{{ "portal.ContactUs" | translate }}</span></ng-template>
            </div>
          </button>
        </div>
        <ng-template #noPlans>
          <p class="wiz__card-sub">{{ "joinTenant.NoPlansHint" | translate }}</p>
        </ng-template>
      </div>

      <!-- Step 3: Contact + review -->
      <div *ngIf="step === 3">
        <h2 class="wiz__card-title">{{ "joinTenant.ContactCardTitle" | translate }}</h2>
        <p class="wiz__card-sub">{{ "joinTenant.ContactCardSub" | translate }}</p>

        <div class="field-row">
          <div class="field">
            <label class="field__label" for="contactName">{{ "joinTenant.ContactNameLabel" | translate }}</label>
            <div class="field__group field__group--icon">
              <i class="bi bi-person field__icon"></i>
              <input id="contactName" type="text" class="field__input" formControlName="contactName" [placeholder]="'joinTenant.ContactNamePlaceholder' | translate" />
            </div>
            <small class="field__error" *ngIf="f['contactName'].touched && f['contactName'].invalid">{{ "joinTenant.ContactNameError" | translate }}</small>
          </div>
          <div class="field">
            <label class="field__label" for="phone">{{ "joinTenant.PhoneLabel" | translate }}</label>
            <div class="field__group field__group--icon">
              <i class="bi bi-telephone field__icon"></i>
              <input id="phone" type="tel" class="field__input" formControlName="phone" [placeholder]="'joinTenant.PhonePlaceholder' | translate" />
            </div>
          </div>
        </div>

        <div class="field">
          <label class="field__label" for="email">{{ "joinTenant.EmailLabel" | translate }}</label>
          <div class="field__group field__group--icon">
            <i class="bi bi-envelope field__icon"></i>
            <input id="email" type="email" class="field__input" formControlName="email" [placeholder]="'joinTenant.EmailPlaceholder' | translate" />
          </div>
          <small class="field__error" *ngIf="f['email'].touched && f['email'].invalid">{{ "auth.InvalidEmail" | translate }}</small>
        </div>

        <div class="field">
          <label class="field__label" for="message">{{ "joinTenant.MessageLabel" | translate }}</label>
          <textarea id="message" rows="3" class="field__input" formControlName="message"
            [placeholder]="'joinTenant.MessagePlaceholder' | translate"></textarea>
        </div>

        <!-- Summary -->
        <div class="summary">
          <p class="summary__title">{{ "joinTenant.OrderSummary" | translate }}</p>
          <div class="summary__row"><span>{{ "joinTenant.Organization" | translate }}</span><strong>{{ f['organizationName'].value || '—' }}</strong></div>
          <div class="summary__row" *ngIf="orgType"><span>{{ "joinTenant.Type" | translate }}</span><strong>{{ orgTypeLabel }}</strong></div>
          <div class="summary__row"><span>{{ "joinTenant.Address" | translate }}</span><strong>{{ subdomainPreview }}</strong></div>
          <div class="summary__row" *ngIf="plans.length"><span>{{ "joinTenant.Plan" | translate }}</span><strong>{{ selectedPlanName }}</strong></div>
        </div>

        <div class="wiz__error" *ngIf="errorMessage">{{ errorMessage }}</div>
      </div>

      <!-- Footer nav -->
      <div class="wiz__nav">
        <button type="button" class="wiz__btn wiz__btn--ghost" (click)="back()" *ngIf="step > 1">
          <i class="bi bi-chevron-left portal-arrow"></i> {{ "joinTenant.Back" | translate }}
        </button>
        <span class="wiz__nav-spacer"></span>
        <button type="button" class="wiz__btn wiz__btn--dark" (click)="next()" *ngIf="step < lastStep"
          [disabled]="!canAdvance">
          {{ "joinTenant.Continue" | translate }} <i class="bi bi-arrow-right portal-arrow"></i>
        </button>
        <button type="submit" class="wiz__btn wiz__btn--primary" *ngIf="step === lastStep" [disabled]="submitting">
          <i class="bi bi-stars"></i> {{ (submitting ? "joinTenant.Sending" : "joinTenant.LaunchMyAcademy") | translate }}
        </button>
      </div>
    </form>

    <p class="wiz__signin">{{ "joinTenant.AlreadyHaveAccount" | translate }} <a routerLink="/account/login">{{ "joinTenant.SignIn" | translate }}</a></p>
  </div>

  <!-- ── Success ──────────────────────────────────────────────────────────── -->
  <ng-template #done>
    <div class="success">
      <div class="success__icon"><i class="bi bi-check-lg"></i></div>
      <h2 class="success__title">{{ "joinTenant.SuccessTitle" | translate }}</h2>
      <p class="success__text">
        {{ "joinTenant.SuccessPrefix" | translate }} <strong>{{ f['organizationName'].value || 'your academy' }}</strong>{{ "joinTenant.SuccessMiddle" | translate }} <strong>{{ f['email'].value }}</strong> {{ "joinTenant.SuccessSuffix" | translate }}
      </p>
      <div class="success__url">
        <span class="success__url-label">{{ "joinTenant.AcademyAddress" | translate }}</span>
        <span class="success__url-value">{{ subdomainPreview }}</span>
      </div>
      <div class="success__actions">
        <a routerLink="/portal" class="wiz__btn wiz__btn--primary"><i class="bi bi-arrow-left portal-arrow"></i> {{ "joinTenant.BackToHome" | translate }}</a>
        <button type="button" class="wiz__btn wiz__btn--ghost" (click)="resetForm()">{{ "joinTenant.SubmitAnother" | translate }}</button>
      </div>
    </div>
  </ng-template>
</div>
